import { Bounce } from "react-toastify";

/**
 * Produces the complete ToastContainer policy without coupling it to Layout.
 * Browser callers intentionally receive the exact pre-rail container literal.
 */
export function getToastContainerConfig({ isMobileApp, isMobile, isDark }) {
  if (!isMobileApp) {
    return {
      position: isMobile ? "top-center" : "bottom-left",
      autoClose: 3000,
      hideProgressBar: false,
      newestOnTop: false,
      closeOnClick: true,
      rtl: false,
      pauseOnFocusLoss: true,
      draggable: true,
      pauseOnHover: true,
      theme: isDark ? "dark" : "light",
      transition: Bounce,
    };
  }

  return {
    position: "bottom-center",
    autoClose: 6000,
    hideProgressBar: true,
    // MUST stay false while `stacked` is on. v11's stack effect hands the
    // front (visible) slot to the LAST toast in DOM order, and `newestOnTop:
    // true` puts the newest toast FIRST in the DOM — so the newest message and
    // its +N badge rendered on a capsule collapsed behind the front one with
    // its children at opacity 0. A second toast arriving while one showed was
    // invisible until the older one expired. With `false`, DOM order is
    // oldest-first and the front slot is the newest toast — which is also the
    // controller's `visibleId`, so the +N badge lands on the capsule the user
    // actually sees.
    newestOnTop: false,
    closeOnClick: false,
    rtl: false,
    pauseOnFocusLoss: true,
    draggable: true,
    draggableDirection: "x",
    // v11 defaults this to 80, and its removal distance is
    // `capsuleWidth * draggablePercent / 100` -- on a 310px capsule that is a
    // 248px drag, two thirds of a phone screen, to get rid of a status toast.
    // 30% is ~93px: still a deliberate movement rather than a stray touch, but
    // reachable with one thumb. The rail's own flick gesture (24px + velocity)
    // remains the fast path; this is the slow-drag path it sits alongside.
    draggablePercent: 30,
    pauseOnHover: true,
    theme: isDark ? "dark" : "light",
    transition: Bounce,
    stacked: true,
    closeButton: false,
    className: "toast-rail-container",
    toastClassName: "toast-rail",
  };
}
